import { useEffect, useState } from 'react';
import { FormField } from 'ui/formField';
import { InputText } from 'ui/inputs';

type ConfirmationImportInputProps = {
  onChange: (isValid: boolean) => void;
  env: string;
};

export const ConfirmImportInput = ({ onChange, env }: ConfirmationImportInputProps) => {
  const [confirmationText, setConfirmationText] = useState('');

  useEffect(() => onChange(confirmationText === env), [confirmationText === env]);

  return (
    <FormField labelText={`Please type in '${env}' to confirm these changes`}>
      <InputText placeholder={env} value={confirmationText} onChange={setConfirmationText} />
    </FormField>
  );
};
